import { PHONE_REGEX } from '../../../../shared/constants';

export const validatePhone = (phone: string = '') => {
  return PHONE_REGEX.test(phone);
};
